import React from 'react';
import { TextInput, usePermissions } from 'react-admin';
import ListHeaderWithFilters from '../../../../components/ListHeaderWithFilters';

const ListHeader = props => {
  const { permissions } = usePermissions();

  return <ListHeaderWithFilters
    {...props}
    title={<div>Teammates</div>}
    createBtnLabel="team_mates_create"
    createBtnLabelSmall="team_mates_create_small"
    customUrl="teammates/create">
    {permissions === 'ROLE_ADMIN' ? <TextInput label="Search by account id" source="account" alwaysOn/> : null}
    <TextInput
      label="Search by teammate"
      source="email"
      alwaysOn
      fullWidth={true}
    />
  </ListHeaderWithFilters>;
};

export default ListHeader;
